import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {t} from 'i18next'
import { Card, CardBody, Button, Collapse } from 'reactstrap'
import { useRecoilValue } from 'recoil'
import axios from 'axios'
import Swal from 'sweetalert2'
import { Accordion } from 'react-bootstrap';

import env from '../../env/src_config'
import { headersState } from '../../recoil/recoil';
import Spinner from '../spinner/Spinner'
import PaginationTop from '../Pagination/PaginationTop'
import PaginationBottom from '../Pagination/PaginationBottom'
import { axiosError, errorStatus } from '../../helpers/response'
import { isNull } from '../../izUtils'
import { transformer } from '../../helpers/fields'
import FutureExceptionList from './lists/FutureExceptionList'
import Loader from '../spinner/Loader'
import Filter from '../filters/Filter'

const FutureException = ({ selectedUsers }) => {
    const navigate = useNavigate();

    const headers = useRecoilValue(headersState);
    const [isOpen, setIsOpen] = useState(null);
    const [exceptions, setExpections] = useState(null)
    const [filters, setFilters] = useState(null)
    const [tableLoading, setTableLoading] = useState(false)

    const lsFilterName = 'AKODA.futureExceptionFilter';

    useEffect(() => {
        getExceptions({});

        return () => {
            localStorage.removeItem(lsFilterName)
        }
    }, [selectedUsers]) // eslint-disable-line react-hooks/exhaustive-deps

    const getExceptions = (passedFilters) => {
        setTableLoading(true);

        const keys = Object.keys(passedFilters);
        let payload = { filters: {} };
        for (let i = 0; i < keys.length; i++) {
            if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                payload.filters[keys[i]] = passedFilters[keys[i]].value;
            } else {
                payload.filters[keys[i]] = "";
            }
        }

        payload.filters.technicians = selectedUsers;

        axios.post(env.api + '/api/user/exception/list', payload, {headers}).then(response => {
            if (!isNull(response.data.data)) {
                setExpections(response.data.data);
                if (!isNull(response.data.filters)) {
                    let transformedFilters = transformer(response.data.filters);
                    setFilters(transformedFilters);
                    localStorage.setItem(lsFilterName, JSON.stringify(transformedFilters))
                }
            }
        }).catch(error => {
            axiosError(error, navigate);
        }).finally(() => {
            setTableLoading(false);
        });
    }

    const handleDelete = (row) => {
        axios.delete(env.api + '/api/user/exception/' + row.id, {headers}).then(response => {
            if (response.data.state === 'success') {
                getExceptions({});
                Swal.fire({
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonColor: 'var(--theme-default)',
                    confirmButtonText: t('ok'),
                })
            } else {
                errorStatus(response.data, t);
            }
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const clearData = () => {
        localStorage.removeItem(lsFilterName);
        getExceptions({});
    }

    if (isNull(exceptions)) {
        return <Spinner />
    } else {
        const filterFields = ['exception_type', 'exception_other', 'from', 'to', 'created_by']
        return (
            <Card className="ribbon-wrapper">
                <CardBody>
                    {tableLoading && <Loader />}
                    <div className="ribbon ribbon-clip ribbon-primary">{t('schedule.futureException.title')}</div>
                    <div>
                        <Accordion className='mb-3'>
                            <div className="default-according style-1" id="clientfilter">
                                <Button color="secondary" className="acc-btn d-flex justify-content-between align-items-center" data-toggle="collapse" onClick={() => setIsOpen(!isOpen)}>
                                    {t('filters')}
                                    <div className={'filter-icon' + (isOpen ? ' rotate-icon' : '')}>
                                        <i className="fa fa-chevron-down"></i>
                                    </div>
                                </Button>
                                <Collapse isOpen={isOpen}>
                                    <div className='p-3'>
                                        <Filter filterFields={filterFields} filters={filters} getData={(clonedFilters) => getExceptions(clonedFilters)} lsFilterName={lsFilterName} clearData={clearData} />
                                    </div>
                                </Collapse>
                            </div>
                        </Accordion>
                        <PaginationTop filters={filters} getData={clonedFilters => getExceptions(clonedFilters)} />
                        <FutureExceptionList data={exceptions} handleDelete={handleDelete} filters={filters} getData={clonedFilters => getExceptions(clonedFilters)} />
                        <PaginationBottom filters={filters} getData={clonedFilters => getExceptions(clonedFilters)} />
                    </div>
                </CardBody>
            </Card>
        )
    }
}

export default FutureException